
import { defineComponent, PropType, ref } from "vue"
import { MAData } from "@/models/ma/MAData"
import EmbedCode from "./EmbedCode.vue"
import { setDynamics365KnownCache, trySetMSCIAuthId } from "@/services/MarketingAutomationApi"

export default defineComponent({
  components: { EmbedCode },
  props: {
    config: {
      type: Object as PropType<MAData>,
      required: true
    }
  },
  emits: ["formsubmitted"],
  setup(props, { emit }) {
    const root = ref<HTMLElement>()
    const formRoot = ref<HTMLElement>()
    const embed_code_cleaned = ref<string>()

    const formSubmitted = (ev: any) => {
      console.log(ev)

      // Helper: get field by a list of possible names
      const fields = ev?.detail?.payload?.fields ?? [] as any[];
      const getFieldValueByNames = (names: string[]) => {
        for (const f of fields)
          if (names.some(n => f.key?.toLowerCase() == n.toLowerCase())) return f.value;
        return null;
      };

      trySetMSCIAuthId(getFieldValueByNames(['email', 'emailaddress1']));
      setDynamics365KnownCache(true)
      emit("formsubmitted")
    }

    const renderForm = () => {
      setTimeout(() => {
        let el = formRoot.value?.querySelector('[data-form-id2]');

        root.value?.appendChild(window.d365mktforms?.createForm(
          el?.getAttribute('data-form-id2'),
          el?.getAttribute('data-form-api-url'),
          el?.getAttribute('data-cached-form-url'))
        );

      }, 200)
    }

    // append data-load-mode="manual" to embed_code
    // to avoid loading the form automatically

    embed_code_cleaned.value = props.config?.embed_code?.replace('data-form-id=', 'data-load-mode="manual" data-form-id2=')

    return {
      formSubmitted,
      root,
      formRoot,
      embed_code_cleaned,
      renderForm
    }
  },
  mounted() {
    document.addEventListener("d365mkt-formsubmit", this.formSubmitted);
  },
  unmounted() {
    document.removeEventListener("d365mkt-formsubmit", this.formSubmitted);
  }
})
